import { Component, Input, OnInit } from '@angular/core';

export enum EInterfaceValues {
    NDC = 'NDC'
}

@Component({
    selector: 'interface-flag',
    template: `<sup *ngIf="interface"
                    [class.ndc]="interface === interfaceValues.NDC">{{interface}}</sup>`,
    styles: [`
        sup {
            padding: 0 .375rem;
        }

        .ndc {
            background: cornflowerblue;
            color: white;
        }
    `]
})

export class InterfaceFlagComponent {

    @Input()
    public interface?: EInterfaceValues;

    public interfaceValues: typeof EInterfaceValues = EInterfaceValues;

}
